'use client'

import { m } from 'framer-motion'
import { ArrowRight, Check } from 'lucide-react'

type FinalCtaSuccessProps = {
  onReset: () => void
}

export function FinalCtaSuccess({ onReset }: FinalCtaSuccessProps) {
  return (
    <m.div
      key="success"
      data-testid="lead-success-state"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      className="py-16 text-center"
    >
      <m.div className="relative mx-auto mb-8 h-24 w-24">
        {[...Array(8)].map((_, index) => (
          <m.div
            key={index}
            initial={{ opacity: 0, scale: 0, x: 0, y: 0 }}
            animate={{
              opacity: [0, 1, 0],
              scale: [0, 1, 0],
              x: Math.cos((index * 45 * Math.PI) / 180) * 60,
              y: Math.sin((index * 45 * Math.PI) / 180) * 60,
            }}
            transition={{ delay: 0.3 + index * 0.05, duration: 0.8, ease: 'easeOut' }}
            className="absolute top-1/2 left-1/2 h-3 w-3 rounded-full bg-emerald-400"
          />
        ))}

        <m.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', delay: 0.2 }}
          className="flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-teal-500 shadow-[0_0_60px_rgba(16,185,129,0.4)]"
        >
          <m.div
            initial={{ scale: 0, rotate: -45 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ delay: 0.4, type: 'spring' }}
          >
            <Check className="h-12 w-12 text-white" strokeWidth={3} />
          </m.div>
        </m.div>
      </m.div>

      <m.h3
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="mb-4 text-3xl font-bold"
      >
        Заявка отправлена!
      </m.h3>

      <m.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="mb-8 text-lg text-gray-400"
      >
        Мы свяжемся с вами в ближайшее время
      </m.p>

      <m.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7 }}
        onClick={onReset}
        className="inline-flex items-center gap-2 text-blue-400 transition-colors hover:text-blue-300"
      >
        Отправить еще одну заявку
        <ArrowRight className="h-4 w-4" />
      </m.button>
    </m.div>
  )
}
